import { create } from 'zustand';

type State = {
    isVisible: boolean;
    isValid: boolean;
    hasBeenModified: boolean;
    address: {
        foreigner: boolean;
        // name: string | null,
        // document: string | null,
        // cep: string | null,
        address: string | null;
        number: string | null;
        neighborhood: string | null;
        city: string | null;
        state: string | null;
        complement: string | null;
        zipCode: string | null;
        countryIso2: string | null;
    };
};

type Action = {
    close: () => void;
    update: (data: Partial<State>) => void;
};

export const useAddressModalStore = create<State & Action>(set => ({
    isVisible: false,
    isValid: false,
    hasBeenModified: false,
    address: {
        foreigner: false,
        name: null,
        document: null,
        cep: null,
        address: null,
        number: null,
        neighborhood: null,
        city: null,
        state: null,
        complement: null,
        zipCode: null,
        countryIso2: null,
    },
    close: () => {
        set(() => ({
            isVisible: false,
        }));
    },
    update: (data: Partial<State>) => {
        set(state => ({
            ...state,
            ...data,
            hasBeenModified: true,
        }));
    },
}));
